import type { BundleItem } from "@p0security/shared/types/bundle";
import { useCallback } from "react";

import { InlineBundleResourceEditor } from "./InlineBundleResourceEditor";

export const UngroupedEditor: React.FC<{
  entryKey: string;
  excludeIntegrations: string[];
  onEntryChange: (key: string, item: BundleItem | undefined) => void;
  onEntryRemove: (key: string) => void;
  onIntegrationSelect: (key: string, integration: string) => void;
  onAvailableIntegrations: (keys: string[]) => void;
}> = ({
  entryKey,
  excludeIntegrations,
  onEntryChange,
  onEntryRemove,
  onIntegrationSelect,
  onAvailableIntegrations,
}) => {
  const handleChange = useCallback(
    (item: BundleItem | undefined) => onEntryChange(entryKey, item),
    [entryKey, onEntryChange]
  );
  const handleRemove = useCallback(
    () => onEntryRemove(entryKey),
    [entryKey, onEntryRemove]
  );
  const handleIntegrationSelect = useCallback(
    (integration: string) => onIntegrationSelect(entryKey, integration),
    [entryKey, onIntegrationSelect]
  );
  return (
    <InlineBundleResourceEditor
      onChange={handleChange}
      onRemove={handleRemove}
      excludeIntegrations={excludeIntegrations}
      onIntegrationSelect={handleIntegrationSelect}
      onAvailableIntegrations={onAvailableIntegrations}
    />
  );
};
